export const SamplesAccountId = '00000000-0000-0000-0000-000000000000';

export enum PrivacyMode {
  PUBLIC = 'Public',
  PRIVATE = 'Private'
}
